import React from "react";
import {Outlet} from "react-router-dom";

export const PrivateRoute = (props) => {
    return (<Outlet {...props} />);
}
